module.exports = __webpack_public_path__ + "img/logo.812ebc4c.png";